import { CurrencyDispatcher } from '~/flux/dispatchers';
import mutationInitNewCavernsMap from '~/graphql/caverns/mutationInitNewCavernsMap';
import { GraphQlRequestError } from '~/graphql/graphqlClient';
import { logError } from '~/logger';
import messages, { CavernsStoreMessage } from '../messages';

export default async function initNewCavernsMap(
  {
    playerId,
    setPendingCavernsTravel,
    setCurrentGameSubmode,
    emit,
  }: {
    playerId: string | null;
    setPendingCavernsTravel: (val: boolean) => void;
    setCurrentGameSubmode: (val: string) => void;
    emit: (message: CavernsStoreMessage, data?: any) => void;
  },
  { startingLevel, game_submode }: { startingLevel: number; game_submode: string; }
) {
  if (!playerId) {
    throw new Error('Player ID is required');
  }

  try {
    setPendingCavernsTravel(true);

    const data = await mutationInitNewCavernsMap({
      playerId,
      startingLevel,
      gameSubmode: game_submode,
    });

    data.currency2 !== null &&
      CurrencyDispatcher.handleCurrencyAction({
        actionType: CurrencyDispatcher.NEW_CURRENCY_BALANCE,
        currency2: data.currency2,
      });

    setCurrentGameSubmode(data.game_submode);
    emit(messages.ENTERED_CAVERNS, data);
  } catch (err) {
    if ((err as GraphQlRequestError).errors.find((error) => error.message === 'Insufficient gold')) {
      CurrencyDispatcher.handleCurrencyAction({
        actionType: CurrencyDispatcher.INSUFFICIENT_GOLD,
      });
      return;
    }

    logError(err, {
      module: 'CavernsStore',
      func: 'initNewCavernsMap',
      playerId,
      startingLevel,
      game_submode,
    });
  } finally {
    setPendingCavernsTravel(false);
  }
}
